import { Box, createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { FC, ReactNode } from 'react';

export interface ConfigurationListItem {
  title: string;
  iconComponent: ReactNode;
  testId?: string;
}

export interface ConfigurationUnderwriterListProps {
  items: ConfigurationListItem[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      alignItems: 'center',
      display: 'flex',
      gap: theme.spacing(1.5),
    },
    icon: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      height: 48,
      justifyContent: 'center',
      width: 48,
      '& img, & svg': {
        display: 'block',
        height: '100%',
        objectFit: 'contain',
        width: '100%',
      },
    },
  }),
);

export const ConfigurationUnderwriterList: FC<ConfigurationUnderwriterListProps> = ({ items }) => {
  const classes = useStyles();

  if (items.length === 0) {
    return null;
  }

  return (
    <Grid container spacing={3}>
      {items.map((item) => (
        <Grid item xs={12} sm={6} key={item.title} data-testid={item.testId}>
          <Box className={classes.item}>
            <Box className={classes.icon}>{item.iconComponent}</Box>
            <Typography variant="body1">{item.title}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
